/** @jsxImportSource @emotion/react */

import { memo } from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";

import { AppBar as AppBarComp, Tab, Toolbar, Typography } from "@material-ui/core";

import { Icon, Button } from "..";
import { Props as ButtonProps } from "../Button";
import CustomTabs from "../TabPanel";

import { appBar, back, icon as iconStyle, title as titleStyle, btn, toolBar, toolBarHeader, tabs } from "./styles";

export interface Action extends ButtonProps {
  label: string;
  primary?: boolean;
  icon?: string;
}

interface Tab {
  label: string;
  value: string;
  disabled?: boolean;
}

interface TabConfig {
  tabKey: string;
  tabs: Tab[];
  onTabChange: (e: any, value: string) => void;
}

interface Props {
  title: string;
  backTo?: string;
  backClick?: () => void;
  titleIcon?: string;
  actions?: Action[];
  tabConfig?: TabConfig;
}

const AppBar = ({ backTo, backClick, titleIcon, title, actions, tabConfig }: Props): JSX.Element => {
  const { push } = useHistory();

  const renderActions = (): JSX.Element[] =>
    // @ts-expect-error
    actions.map(({ primary, color, label, variant = "contained", icon, ...rest }, i) => (
      <Button
        // eslint-disable-next-line react/no-array-index-key
        key={`btn-${i}`}
        css={btn}
        variant={variant}
        color={primary ? "primary" : color}
        icon={icon}
        {...rest}
      >
        {label}
      </Button>
    ));

  const renderTabs = (): JSX.Element => (
    <CustomTabs value={tabConfig?.tabKey} onChange={tabConfig?.onTabChange} css={tabs}>
      {(tabConfig?.tabs ?? []).map(({ label, value, disabled }) => (
        <Tab label={label} value={value} disabled={disabled} />
      ))}
    </CustomTabs>
  );

  return (
    <AppBarComp css={appBar} position="fixed">
      <Toolbar>
        <div css={toolBar}>
          <div css={toolBarHeader}>
            {(backTo || backClick) && (
              <Button
                css={back}
                icon="arrow-left"
                variant="contained"
                color="white"
                onClick={(): void => {
                  if (backClick) {
                    backClick();
                  } else {
                    push(backTo || "");
                  }
                }}
              >
                <FormattedMessage id="btn.back" />
              </Button>
            )}
            {!backTo && titleIcon && <Icon css={iconStyle} name={titleIcon} />}
            <Typography css={titleStyle} variant="h5" noWrap>
              {title}
            </Typography>
            {actions && renderActions()}
          </div>
          {tabConfig && renderTabs()}
        </div>
      </Toolbar>
    </AppBarComp>
  );
};

export default memo(AppBar);
